<div [class]="{ 'span-button': true, 'cancel': cancel, 'disabled': disabled }">
    <span class="button-label">{{ label }}</span>
</div>